import { Fragment } from "react";
import { titleCase } from "change-case-all";
import { useNavigate } from "react-router-dom";
import {
  Dialog as MUIDialog,
  DialogContent,
  Grid,
  Typography,
  DialogActions,
} from "@mui/material";

import pages from "../../../constants/pages";
import { colors } from "../../css components/Style";
import { CancelButton, PrimaryButton } from "../../css components/Button";

export default function AudienceDetails({ audienceDialog, setAudienceDialog }) {
  const navigate = useNavigate();

  const handleClose = () => {
    setAudienceDialog({ state: false, data: {} });
  };

  const renderField = (field, index) => {
    const excludeKeys = [
      "mandatory",
      "is_additional",
      "userCount",
      "field_id",
      "is_edit",
      "percentage",
      "audience_id",
      "is_editable",
      "isEditable",
      "tentative_size",
      "audience_group",
      "category",
      "tentative_audience",
    ];

    return Object.entries(field)
      .filter(([key]) => !excludeKeys.includes(key))
      .map(([key, value]) => (
        <Fragment>
          <Grid size={4}>
            <Typography fontWeight="bold">
              {titleCase(key.replace(/_/g, " "))}
            </Typography>
          </Grid>
          <Grid size={8}>
            <Typography>
              {Array.isArray(value)
                ? value.length === 1 && value[0] === "ALL"
                  ? ""
                  : value.filter((item) => item !== "ALL").join(", ")
                : value &&
                  typeof value === "object" &&
                  "min" in value &&
                  "max" in value
                ? `Min: ${value.min}, Max: ${value.max}`
                : String(value)}
            </Typography>
          </Grid>
        </Fragment>
      ));
  };

  return (
    <Fragment>
      <MUIDialog
        slotProps={{
          paper: {
            sx: {
              borderRadius: "12px",
            },
          },
        }}
        open={audienceDialog.state}
        onClose={handleClose}
      >
        <DialogContent style={{ padding: "24px" }}>
          <Grid container spacing={4}>
            <Grid size={12}>
              <Typography variant="h6" color={colors.publicisBlue}>
                Audience Fields
              </Typography>
            </Grid>

            {renderField(audienceDialog.data)}
          </Grid>
        </DialogContent>

        <DialogActions style={{ padding: "16px 24px" }}>
          <PrimaryButton
            onClick={() => {
              navigate(pages.createCampaign.route);
            }}
            variant="contained"
          >
            Activate Audience Cohort
          </PrimaryButton>
          <CancelButton variant="outlined" onClick={handleClose}>
            Cancel
          </CancelButton>
        </DialogActions>
      </MUIDialog>
    </Fragment>
  );
}
